import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { TranslationTaskNameGetter, TranslationTaskNameSetter } from '../task-name-manager';
import { TaskNameService } from '@/services/task-name-service/task-name-service';
import { TranslateModel } from '../../models/translate-model';
import { RavenService } from '@telecom/shared/services/raven-service/raven-service';
import * as TrackEvents from '@/constants/track-events';
import { TRACK_EVENT_TYPE } from '@/constants';

/**
 * 翻译任务名称管理器
 */
@injectable()
export class TranslationTaskNameManager implements TranslationTaskNameGetter, TranslationTaskNameSetter {
    constructor(
        @inject(TranslateModel)
        private readonly _aiTranslationModel: TranslateModel,
        @inject(TaskNameService)
        private readonly _taskNameService: TaskNameService,
        @inject(RavenService)
        private readonly _ravenService: RavenService,
    ) {}

    async getTaskName(taskId: string): Promise<string> {
        this._ravenService.track(TrackEvents.TRACK_EVENT_GET_TASK_NAME, {
            eventType: TRACK_EVENT_TYPE.Translation,
            otherParam: taskId,
        });
        const title = await this._taskNameService.getTaskName(taskId);
        this._aiTranslationModel.update((state) => ({
            ...state,
            title,
        }));
        return title;
    }

    setTaskName(taskId: string, taskName: string): Promise<void> {
        this._ravenService.track(TrackEvents.TRACK_EVENT_SET_TASK_NAME, {
            eventType: TRACK_EVENT_TYPE.Translation,
            otherParam: taskId,
        });
        let title = '';
        this._aiTranslationModel.update((state) => {
            title = state.title;
            return {
                ...state,
                title: taskName,
            };
        });

        return this._taskNameService.setTaskName(taskId, taskName).catch((error) => {
            this._aiTranslationModel.update((state) => ({
                ...state,
                title,
            }));
            throw error;
        });
    }
}
